import Vue from 'vue';

function jsonFilter(obj: any) {
    return JSON.stringify(obj, undefined, 2);
}

Vue.filter('json', jsonFilter);

export default jsonFilter;
